const _baseImageUrl = "https://cms.erik-yeghiazaryan.site/cockpit-core/storage/uploads"
const _CHAT_ID = process.env.REACT_APP_CHAT_ID
const _TG_TOKEN_BOT = process.env.REACT_APP_TG_TOKEN_BOT
const _TG_URL = `https://api.telegram.org/bot${_TG_TOKEN_BOT}/sendMessage`
const _CMS_URL = "https://cms.erik-yeghiazaryan.site/cockpit-core/api/content/items/"



export {
    _baseImageUrl,
    _CHAT_ID,
    _TG_TOKEN_BOT,
    _TG_URL,
    _CMS_URL }